import React from 'react';
import PropTypes from 'prop-types';
import MenuInputWithTitle from '../components/MenuInputWithTitle';
import messages from './messages';

const AvgNetPriceInput = ({ onChange, value = '', showError, title, maxLength, inputId }) => (
  <MenuInputWithTitle
    inputId={inputId}
    type="number"
    maxLength={maxLength}
    title={title}
    value={value}
    onChange={onChange}
    isErrorVisible={showError}
  />
);

AvgNetPriceInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  title: PropTypes.object,
  maxLength: PropTypes.string,
  inputId: PropTypes.string,
  showError: PropTypes.bool,
};

const AvgNetPrices = ({ onChange, initialValue }) => (
  <React.Fragment>
    <AvgNetPriceInput
      title={messages['0-30']}
      inputId="avg-net-prices-0-30"
      value={initialValue['0-30'].value}
      showError={initialValue['0-30'].showError}
      onChange={(e) => {
        onChange(e, {
          '0-30': { ...initialValue['0-30'], value: e.target.value },
        });
      }}
      maxLength="6"
    />
    <AvgNetPriceInput
      inputId="avg-net-prices-30-48"
      title={messages['30-48']}
      value={initialValue['30-48'].value}
      showError={initialValue['30-48'].showError}
      onChange={(e) => {
        onChange(e, {
          '30-48': { ...initialValue['30-48'], value: e.target.value },
        });
      }}
      maxLength="5"
    />
    <AvgNetPriceInput
      inputId="avg-net-prices-48-75"
      title={messages['48-75']}
      value={initialValue['48-75'].value}
      showError={initialValue['48-75'].showError}
      onChange={(e) => {
        onChange(e, {
          '48-75': { ...initialValue['48-75'], value: e.target.value },
        });
      }}
      maxLength="5"
    />
    <AvgNetPriceInput
      inputId="avg-net-prices-75-110"
      title={messages['75-110']}
      value={initialValue['75-110'].value}
      showError={initialValue['75-110'].showError}
      onChange={(e) => {
        onChange(e, {
          '75-110': { ...initialValue['75-110'], value: e.target.value },
        });
      }}
      maxLength="5"
    />
    <AvgNetPriceInput
      inputId="avg-net-prices-110-plus"
      title={messages['110+']}
      value={initialValue['110+'].value}
      showError={initialValue['110+'].showError}
      onChange={(e) => {
        onChange(e, {
          '110+': { ...initialValue['110+'], value: e.target.value },
        });
      }}
      validation={!!initialValue['110+'].value && !initialValue['110+'].value.match(/^\d+$/)}
    />
  </React.Fragment>
);

AvgNetPrices.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default AvgNetPrices;
